import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { parentSupervisionActions } from '../../../../../store';

import type { Moment } from 'moment';

function useBackdateSupervision(supervisionId: number | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmBackdateDialog, setShowConfirmBackdateDialog] = useState(false);
  const [pendingBackdateDate, setPendingBackdateDate] = useState<Moment | null>(null);
  const [pendingBackdateUtcOffset, setPendingBackdateUtcOffset] = useState<number | null>(null);

  const requestBackdate = useCallback((backdatedDate: Moment, utcOffset: number | null) => {
    setPendingBackdateDate(backdatedDate);
    setPendingBackdateUtcOffset(utcOffset);
    setShowConfirmBackdateDialog(true);
  }, []);

  const handleBackdateSupervision = useCallback(async () => {
    if (!supervisionId || !pendingBackdateDate) return;
    setShowConfirmBackdateDialog(false);

    const { error } = await dispatch(
      parentSupervisionActions.backdateParentSupervision({
        supervisionId: supervisionId,
        data: {
          date_start: pendingBackdateDate,
          utc_offset_date_start: pendingBackdateUtcOffset ?? 0,
        },
        getAccessTokenSilently: getAccessTokenSilently,
      }),
    );

    if (!error) {
      location.reload();
    }
  }, [
    dispatch,
    getAccessTokenSilently,
    supervisionId,
    pendingBackdateDate,
    pendingBackdateUtcOffset,
  ]);

  return {
    showConfirmBackdateDialog,
    setShowConfirmBackdateDialog,
    requestBackdate,
    handleBackdateSupervision,
  };
}

export default useBackdateSupervision;
